import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {Config} from '../models';
import {RootStore} from '../store/root.store';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  config: Config;

  constructor(private readonly rootStore: RootStore) {
    rootStore.getConfig.subscribe((c) => this.config = c);
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const headers = request.headers
      .set('languageCode', this.config.userContext.language);
    const reqClone = request.clone({
      headers, withCredentials: true
    });
    return next.handle(reqClone);
  }
}
